<!-- <div id="container">

    <div class="content">
    
    
        <owl-carousel-o [options]="customOptions" (initialized)="onCarouselInitialized($event)">
          <ng-template carouselSlide><img src="../../assets/sjn.jpeg"></ng-template>  
          <ng-template carouselSlide><img src="../../assets/de.jpg"></ng-template>  
      </owl-carousel-o>
       
    
    </div>
     
    
       
    </div>
    
       -->
<div mat-dialog-content>
  <button class="top-buttons" style="float: right;margin-top: 8px;" (click)="openLink()">Schedule Live
    Pitch</button>
  <button class="top-buttons" style="float: left;margin-top: 8px; margin-left: 8px;" mat-dialog-close>Proceed</button>
  <!-- <owl-carousel-o [options]="customOptions" (initialized)="onCarouselInitialized($event)" class="cont">
    <ng-template carouselSlide><img src="../../assets/sjn.jpeg"></ng-template>  
    <ng-template carouselSlide><img src="../../assets/de.jpg"></ng-template>  
</owl-carousel-o> -->
  <img src="../../assets/2BC30221-7F53-4798-83EB-5B6B3302AA2A.png" alt="" class="poster">
  <br>
  <br>
  <button mat-fab color="#ea601a" class="global-mb btm-btn">
    <mat-icon style="color: #ea601a">keyboard_arrow_down</mat-icon>
  </button>
</div>